// @ts-check
// src/stores/customers.js — Faza E.2 / Sesja 3.5 — Customers state in Nanostores

import { atom } from 'nanostores';

/** Filtry listy klientów: search / status / type / country */
export const $customersFilters = atom(/** @type {Record<string, string>} */ ({}));

/** Aktualna strona */
export const $customersPage = atom(1);

/** Currently selected customer id */
export const $selectedCustomerId = atom(/** @type {string | null} */ (null));

// Sesja 3.5 — dodatkowe atomy migrujące pola z window.__sbState
/** Lista załadowanych klientów (paginowana po 50) */
export const $customersList = atom(/** @type {any[]} */ ([]));

/** Czy trwa fetch listy klientów */
export const $customersLoading = atom(false);

/** Filtr typu (all / company / individual) */
export const $customersFilterType = atom('all');

/** Filtr statusu (all / standard / staly / vip / hurt / czarna_lista) */
export const $customersFilterStatus = atom('all');

/** Filtr kraju */
export const $customersFilterCountry = atom('all');

/** Czy lewy panel filtrów listy klientów jest widoczny */
export const $customersPanelVisible = atom(false);

if (typeof window !== 'undefined') {
  window.__sbStores = Object.assign(window.__sbStores || {}, {
    $customersFilters,
    $customersPage,
    $selectedCustomerId,
    $customersList,
    $customersLoading,
    $customersFilterType,
    $customersFilterStatus,
    $customersFilterCountry,
    $customersPanelVisible,
  });
}
